/******************************************************************************
 * This file was generated by ZenStack CLI.
 ******************************************************************************/

/* eslint-disable */
// @ts-nocheck

import type { Prisma, ImpersonationLog } from ".zenstack/models";
import type { UseMutationOptions, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { getHooksContext } from '@zenstackhq/tanstack-query/runtime-v5/react';
import { useModelQuery, useInfiniteModelQuery, useModelMutation } from '@zenstackhq/tanstack-query/runtime-v5/react';
import type { PickEnumerable, CheckSelect, QueryError, ExtraQueryOptions, ExtraMutationOptions } from '@zenstackhq/tanstack-query/runtime-v5';
import type { PolicyCrudKind } from '@zenstackhq/runtime'
import metadata from './__model_meta';
type DefaultError = QueryError;
import { useSuspenseModelQuery, useSuspenseInfiniteModelQuery } from '@zenstackhq/tanstack-query/runtime-v5/react';
import type { UseSuspenseQueryOptions, UseSuspenseInfiniteQueryOptions } from '@tanstack/react-query';

export function useCreateImpersonationLog(options?: Omit<(UseMutationOptions<(ImpersonationLog | undefined), DefaultError, Prisma.ImpersonationLogCreateArgs> & ExtraMutationOptions), 'mutationFn'>) {
    const { endpoint, fetch } = getHooksContext();
    const _mutation =
        useModelMutation<Prisma.ImpersonationLogCreateArgs, DefaultError, ImpersonationLog, true>('ImpersonationLog', 'POST', `${endpoint}/impersonationLog/create`, metadata, options, fetch, true)
        ;
    const mutation = {
        ..._mutation,
        mutateAsync: async <T extends Prisma.ImpersonationLogCreateArgs>(
            args: Prisma.SelectSubset<T, Prisma.ImpersonationLogCreateArgs>,
            options?: Omit<(UseMutationOptions<(CheckSelect<T, ImpersonationLog, Prisma.ImpersonationLogGetPayload<T>> | undefined), DefaultError, Prisma.SelectSubset<T, Prisma.ImpersonationLogCreateArgs>> & ExtraMutationOptions), 'mutationFn'>
        ) => {
            return (await _mutation.mutateAsync(
                args,
                options as any
            )) as (CheckSelect<T, ImpersonationLog, Prisma.ImpersonationLogGetPayload<T>> | undefined);
        },
    };
    return mutation;
}

export function useCreateManyImpersonationLog(options?: Omit<(UseMutationOptions<Prisma.BatchPayload, DefaultError, Prisma.ImpersonationLogCreateManyArgs> & ExtraMutationOptions), 'mutationFn'>) {
    const { endpoint, fetch } = getHooksContext();
    const _mutation =
        useModelMutation<Prisma.ImpersonationLogCreateManyArgs, DefaultError, Prisma.BatchPayload, false>('ImpersonationLog', 'POST', `${endpoint}/impersonationLog/createMany`, metadata, options, fetch, false)
        ;
    const mutation = {
        ..._mutation,
        mutateAsync: async <T extends Prisma.ImpersonationLogCreateManyArgs>(
            args: Prisma.SelectSubset<T, Prisma.ImpersonationLogCreateManyArgs>,
            options?: Omit<(UseMutationOptions<Prisma.BatchPayload, DefaultError, Prisma.SelectSubset<T, Prisma.ImpersonationLogCreateManyArgs>> & ExtraMutationOptions), 'mutationFn'>
        ) => {
            return (await _mutation.mutateAsync(
                args,
                options as any
            )) as Prisma.BatchPayload;
        },
    };
    return mutation;
}

export function useFindManyImpersonationLog<TArgs extends Prisma.ImpersonationLogFindManyArgs, TQueryFnData = Array<Prisma.ImpersonationLogGetPayload<TArgs> & { $optimistic?: boolean }>, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.ImpersonationLogFindManyArgs>, options?: (Omit<UseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useModelQuery<TQueryFnData, TData, TError>('ImpersonationLog', `${endpoint}/impersonationLog/findMany`, args, options, fetch);
}

export function useInfiniteFindManyImpersonationLog<TArgs extends Prisma.ImpersonationLogFindManyArgs, TQueryFnData = Array<Prisma.ImpersonationLogGetPayload<TArgs>>, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.ImpersonationLogFindManyArgs>, options?: Omit<UseInfiniteQueryOptions<TQueryFnData, TError, InfiniteData<TData>>, 'queryKey' | 'initialPageParam'>) {
    options = options ?? { getNextPageParam: () => null };
    const { endpoint, fetch } = getHooksContext();
    return useInfiniteModelQuery<TQueryFnData, TData, TError>('ImpersonationLog', `${endpoint}/impersonationLog/findMany`, args, options, fetch);
}

export function useSuspenseFindManyImpersonationLog<TArgs extends Prisma.ImpersonationLogFindManyArgs, TQueryFnData = Array<Prisma.ImpersonationLogGetPayload<TArgs> & { $optimistic?: boolean }>, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.ImpersonationLogFindManyArgs>, options?: (Omit<UseSuspenseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useSuspenseModelQuery<TQueryFnData, TData, TError>('ImpersonationLog', `${endpoint}/impersonationLog/findMany`, args, options, fetch);
}

export function useSuspenseInfiniteFindManyImpersonationLog<TArgs extends Prisma.ImpersonationLogFindManyArgs, TQueryFnData = Array<Prisma.ImpersonationLogGetPayload<TArgs>>, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.ImpersonationLogFindManyArgs>, options?: Omit<UseSuspenseInfiniteQueryOptions<TQueryFnData, TError, InfiniteData<TData>>, 'queryKey' | 'initialPageParam'>) {
    options = options ?? { getNextPageParam: () => null };
    const { endpoint, fetch } = getHooksContext();
    return useSuspenseInfiniteModelQuery<TQueryFnData, TData, TError>('ImpersonationLog', `${endpoint}/impersonationLog/findMany`, args, options, fetch);
}

export function useFindUniqueImpersonationLog<TArgs extends Prisma.ImpersonationLogFindUniqueArgs, TQueryFnData = Prisma.ImpersonationLogGetPayload<TArgs> & { $optimistic?: boolean }, TData = TQueryFnData, TError = DefaultError>(args: Prisma.SelectSubset<TArgs, Prisma.ImpersonationLogFindUniqueArgs>, options?: (Omit<UseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useModelQuery<TQueryFnData, TData, TError>('ImpersonationLog', `${endpoint}/impersonationLog/findUnique`, args, options, fetch);
}

export function useSuspenseFindUniqueImpersonationLog<TArgs extends Prisma.ImpersonationLogFindUniqueArgs, TQueryFnData = Prisma.ImpersonationLogGetPayload<TArgs> & { $optimistic?: boolean }, TData = TQueryFnData, TError = DefaultError>(args: Prisma.SelectSubset<TArgs, Prisma.ImpersonationLogFindUniqueArgs>, options?: (Omit<UseSuspenseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useSuspenseModelQuery<TQueryFnData, TData, TError>('ImpersonationLog', `${endpoint}/impersonationLog/findUnique`, args, options, fetch);
}

export function useFindFirstImpersonationLog<TArgs extends Prisma.ImpersonationLogFindFirstArgs, TQueryFnData = Prisma.ImpersonationLogGetPayload<TArgs> & { $optimistic?: boolean }, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.ImpersonationLogFindFirstArgs>, options?: (Omit<UseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useModelQuery<TQueryFnData, TData, TError>('ImpersonationLog', `${endpoint}/impersonationLog/findFirst`, args, options, fetch);
}

export function useSuspenseFindFirstImpersonationLog<TArgs extends Prisma.ImpersonationLogFindFirstArgs, TQueryFnData = Prisma.ImpersonationLogGetPayload<TArgs> & { $optimistic?: boolean }, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.ImpersonationLogFindFirstArgs>, options?: (Omit<UseSuspenseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useSuspenseModelQuery<TQueryFnData, TData, TError>('ImpersonationLog', `${endpoint}/impersonationLog/findFirst`, args, options, fetch);
}

export function useUpdateImpersonationLog(options?: Omit<(UseMutationOptions<(ImpersonationLog | undefined), DefaultError, Prisma.ImpersonationLogUpdateArgs> & ExtraMutationOptions), 'mutationFn'>) {
    const { endpoint, fetch } = getHooksContext();
    const _mutation =
        useModelMutation<Prisma.ImpersonationLogUpdateArgs, DefaultError, ImpersonationLog, true>('ImpersonationLog', 'PUT', `${endpoint}/impersonationLog/update`, metadata, options, fetch, true)
        ;
    const mutation = {
        ..._mutation,
        mutateAsync: async <T extends Prisma.ImpersonationLogUpdateArgs>(
            args: Prisma.SelectSubset<T, Prisma.ImpersonationLogUpdateArgs>,
            options?: Omit<(UseMutationOptions<(CheckSelect<T, ImpersonationLog, Prisma.ImpersonationLogGetPayload<T>> | undefined), DefaultError, Prisma.SelectSubset<T, Prisma.ImpersonationLogUpdateArgs>> & ExtraMutationOptions), 'mutationFn'>
        ) => {
            return (await _mutation.mutateAsync(
                args,
                options as any
            )) as (CheckSelect<T, ImpersonationLog, Prisma.ImpersonationLogGetPayload<T>> | undefined);
        },
    };
    return mutation;
}

export function useUpdateManyImpersonationLog(options?: Omit<(UseMutationOptions<Prisma.BatchPayload, DefaultError, Prisma.ImpersonationLogUpdateManyArgs> & ExtraMutationOptions), 'mutationFn'>) {
    const { endpoint, fetch } = getHooksContext();
    const _mutation =
        useModelMutation<Prisma.ImpersonationLogUpdateManyArgs, DefaultError, Prisma.BatchPayload, false>('ImpersonationLog', 'PUT', `${endpoint}/impersonationLog/updateMany`, metadata, options, fetch, false)
        ;
    const mutation = {
        ..._mutation,
        mutateAsync: async <T extends Prisma.ImpersonationLogUpdateManyArgs>(
            args: Prisma.SelectSubset<T, Prisma.ImpersonationLogUpdateManyArgs>,
            options?: Omit<(UseMutationOptions<Prisma.BatchPayload, DefaultError, Prisma.SelectSubset<T, Prisma.ImpersonationLogUpdateManyArgs>> & ExtraMutationOptions), 'mutationFn'>
        ) => {
            return (await _mutation.mutateAsync(
                args,
                options as any
            )) as Prisma.BatchPayload;
        },
    };
    return mutation;
}

export function useUpsertImpersonationLog(options?: Omit<(UseMutationOptions<(ImpersonationLog | undefined), DefaultError, Prisma.ImpersonationLogUpsertArgs> & ExtraMutationOptions), 'mutationFn'>) {
    const { endpoint, fetch } = getHooksContext();
    const _mutation =
        useModelMutation<Prisma.ImpersonationLogUpsertArgs, DefaultError, ImpersonationLog, true>('ImpersonationLog', 'POST', `${endpoint}/impersonationLog/upsert`, metadata, options, fetch, true)
        ;
    const mutation = {
        ..._mutation,
        mutateAsync: async <T extends Prisma.ImpersonationLogUpsertArgs>(
            args: Prisma.SelectSubset<T, Prisma.ImpersonationLogUpsertArgs>,
            options?: Omit<(UseMutationOptions<(CheckSelect<T, ImpersonationLog, Prisma.ImpersonationLogGetPayload<T>> | undefined), DefaultError, Prisma.SelectSubset<T, Prisma.ImpersonationLogUpsertArgs>> & ExtraMutationOptions), 'mutationFn'>
        ) => {
            return (await _mutation.mutateAsync(
                args,
                options as any
            )) as (CheckSelect<T, ImpersonationLog, Prisma.ImpersonationLogGetPayload<T>> | undefined);
        },
    };
    return mutation;
}

export function useDeleteImpersonationLog(options?: Omit<(UseMutationOptions<(ImpersonationLog | undefined), DefaultError, Prisma.ImpersonationLogDeleteArgs> & ExtraMutationOptions), 'mutationFn'>) {
    const { endpoint, fetch } = getHooksContext();
    const _mutation =
        useModelMutation<Prisma.ImpersonationLogDeleteArgs, DefaultError, ImpersonationLog, true>('ImpersonationLog', 'DELETE', `${endpoint}/impersonationLog/delete`, metadata, options, fetch, true)
        ;
    const mutation = {
        ..._mutation,
        mutateAsync: async <T extends Prisma.ImpersonationLogDeleteArgs>(
            args: Prisma.SelectSubset<T, Prisma.ImpersonationLogDeleteArgs>,
            options?: Omit<(UseMutationOptions<(CheckSelect<T, ImpersonationLog, Prisma.ImpersonationLogGetPayload<T>> | undefined), DefaultError, Prisma.SelectSubset<T, Prisma.ImpersonationLogDeleteArgs>> & ExtraMutationOptions), 'mutationFn'>
        ) => {
            return (await _mutation.mutateAsync(
                args,
                options as any
            )) as (CheckSelect<T, ImpersonationLog, Prisma.ImpersonationLogGetPayload<T>> | undefined);
        },
    };
    return mutation;
}

export function useDeleteManyImpersonationLog(options?: Omit<(UseMutationOptions<Prisma.BatchPayload, DefaultError, Prisma.ImpersonationLogDeleteManyArgs> & ExtraMutationOptions), 'mutationFn'>) {
    const { endpoint, fetch } = getHooksContext();
    const _mutation =
        useModelMutation<Prisma.ImpersonationLogDeleteManyArgs, DefaultError, Prisma.BatchPayload, false>('ImpersonationLog', 'DELETE', `${endpoint}/impersonationLog/deleteMany`, metadata, options, fetch, false)
        ;
    const mutation = {
        ..._mutation,
        mutateAsync: async <T extends Prisma.ImpersonationLogDeleteManyArgs>(
            args: Prisma.SelectSubset<T, Prisma.ImpersonationLogDeleteManyArgs>,
            options?: Omit<(UseMutationOptions<Prisma.BatchPayload, DefaultError, Prisma.SelectSubset<T, Prisma.ImpersonationLogDeleteManyArgs>> & ExtraMutationOptions), 'mutationFn'>
        ) => {
            return (await _mutation.mutateAsync(
                args,
                options as any
            )) as Prisma.BatchPayload;
        },
    };
    return mutation;
}

export function useAggregateImpersonationLog<TArgs extends Prisma.ImpersonationLogAggregateArgs, TQueryFnData = Prisma.GetImpersonationLogAggregateType<TArgs>, TData = TQueryFnData, TError = DefaultError>(args: Prisma.SelectSubset<TArgs, Prisma.ImpersonationLogAggregateArgs>, options?: (Omit<UseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useModelQuery<TQueryFnData, TData, TError>('ImpersonationLog', `${endpoint}/impersonationLog/aggregate`, args, options, fetch);
}

export function useSuspenseAggregateImpersonationLog<TArgs extends Prisma.ImpersonationLogAggregateArgs, TQueryFnData = Prisma.GetImpersonationLogAggregateType<TArgs>, TData = TQueryFnData, TError = DefaultError>(args: Prisma.SelectSubset<TArgs, Prisma.ImpersonationLogAggregateArgs>, options?: (Omit<UseSuspenseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useSuspenseModelQuery<TQueryFnData, TData, TError>('ImpersonationLog', `${endpoint}/impersonationLog/aggregate`, args, options, fetch);
}

export function useGroupByImpersonationLog<TArgs extends Prisma.ImpersonationLogGroupByArgs, HasSelectOrTake extends Prisma.Or<Prisma.Extends<'skip', Prisma.Keys<TArgs>>, Prisma.Extends<'take', Prisma.Keys<TArgs>>>, OrderByArg extends Prisma.True extends HasSelectOrTake ? { orderBy: Prisma.ImpersonationLogGroupByArgs['orderBy'] } : { orderBy?: Prisma.ImpersonationLogGroupByArgs['orderBy'] }, OrderFields extends Prisma.ExcludeUnderscoreKeys<Prisma.Keys<Prisma.MaybeTupleToUnion<TArgs['orderBy']>>>, ByFields extends Prisma.MaybeTupleToUnion<TArgs['by']>, ByValid extends Prisma.Has<ByFields, OrderFields>, HavingFields extends Prisma.GetHavingFields<TArgs['having']>, HavingValid extends Prisma.Has<ByFields, HavingFields>, ByEmpty extends TArgs['by'] extends never[] ? Prisma.True : Prisma.False, InputErrors extends ByEmpty extends Prisma.True
    ? `Error: "by" must not be empty.`
    : HavingValid extends Prisma.False
    ? {
        [P in HavingFields]: P extends ByFields
        ? never
        : P extends string
        ? `Error: Field "${P}" used in "having" needs to be provided in "by".`
        : [
            Error,
            'Field ',
            P,
            ` in "having" needs to be provided in "by"`,
        ]
    }[HavingFields]
    : 'take' extends Prisma.Keys<TArgs>
    ? 'orderBy' extends Prisma.Keys<TArgs>
    ? ByValid extends Prisma.True
    ? {}
    : {
        [P in OrderFields]: P extends ByFields
        ? never
        : `Error: Field "${P}" in "orderBy" needs to be provided in "by"`
    }[OrderFields]
    : 'Error: If you provide "take", you also need to provide "orderBy"'
    : 'skip' extends Prisma.Keys<TArgs>
    ? 'orderBy' extends Prisma.Keys<TArgs>
    ? ByValid extends Prisma.True
    ? {}
    : {
        [P in OrderFields]: P extends ByFields
        ? never
        : `Error: Field "${P}" in "orderBy" needs to be provided in "by"`
    }[OrderFields]
    : 'Error: If you provide "skip", you also need to provide "orderBy"'
    : ByValid extends Prisma.True
    ? {}
    : {
        [P in OrderFields]: P extends ByFields
        ? never
        : `Error: Field "${P}" in "orderBy" needs to be provided in "by"`
    }[OrderFields], TQueryFnData = {} extends InputErrors ?
    Array<PickEnumerable<Prisma.ImpersonationLogGroupByOutputType, TArgs['by']> &
    {
        [P in ((keyof TArgs) & (keyof Prisma.ImpersonationLogGroupByOutputType))]: P extends '_count'
        ? TArgs[P] extends boolean
        ? number
        : Prisma.GetScalarType<TArgs[P], Prisma.ImpersonationLogGroupByOutputType[P]>
        : Prisma.GetScalarType<TArgs[P], Prisma.ImpersonationLogGroupByOutputType[P]>
    }
    > : InputErrors, TData = TQueryFnData, TError = DefaultError>(args: Prisma.SelectSubset<TArgs, Prisma.SubsetIntersection<TArgs, Prisma.ImpersonationLogGroupByArgs, OrderByArg> & InputErrors>, options?: (Omit<UseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useModelQuery<TQueryFnData, TData, TError>('ImpersonationLog', `${endpoint}/impersonationLog/groupBy`, args, options, fetch);
}

export function useSuspenseGroupByImpersonationLog<TArgs extends Prisma.ImpersonationLogGroupByArgs, HasSelectOrTake extends Prisma.Or<Prisma.Extends<'skip', Prisma.Keys<TArgs>>, Prisma.Extends<'take', Prisma.Keys<TArgs>>>, OrderByArg extends Prisma.True extends HasSelectOrTake ? { orderBy: Prisma.ImpersonationLogGroupByArgs['orderBy'] } : { orderBy?: Prisma.ImpersonationLogGroupByArgs['orderBy'] }, OrderFields extends Prisma.ExcludeUnderscoreKeys<Prisma.Keys<Prisma.MaybeTupleToUnion<TArgs['orderBy']>>>, ByFields extends Prisma.MaybeTupleToUnion<TArgs['by']>, ByValid extends Prisma.Has<ByFields, OrderFields>, HavingFields extends Prisma.GetHavingFields<TArgs['having']>, HavingValid extends Prisma.Has<ByFields, HavingFields>, ByEmpty extends TArgs['by'] extends never[] ? Prisma.True : Prisma.False, InputErrors extends ByEmpty extends Prisma.True
    ? `Error: "by" must not be empty.`
    : HavingValid extends Prisma.False
    ? {
        [P in HavingFields]: P extends ByFields
        ? never
        : P extends string
        ? `Error: Field "${P}" used in "having" needs to be provided in "by".`
        : [
            Error,
            'Field ',
            P,
            ` in "having" needs to be provided in "by"`,
        ]
    }[HavingFields]
    : 'take' extends Prisma.Keys<TArgs>
    ? 'orderBy' extends Prisma.Keys<TArgs>
    ? ByValid extends Prisma.True
    ? {}
    : {
        [P in OrderFields]: P extends ByFields
        ? never
        : `Error: Field "${P}" in "orderBy" needs to be provided in "by"`
    }[OrderFields]
    : 'Error: If you provide "take", you also need to provide "orderBy"'
    : 'skip' extends Prisma.Keys<TArgs>
    ? 'orderBy' extends Prisma.Keys<TArgs>
    ? ByValid extends Prisma.True
    ? {}
    : {
        [P in OrderFields]: P extends ByFields
        ? never
        : `Error: Field "${P}" in "orderBy" needs to be provided in "by"`
    }[OrderFields]
    : 'Error: If you provide "skip", you also need to provide "orderBy"'
    : ByValid extends Prisma.True
    ? {}
    : {
        [P in OrderFields]: P extends ByFields
        ? never
        : `Error: Field "${P}" in "orderBy" needs to be provided in "by"`
    }[OrderFields], TQueryFnData = {} extends InputErrors ?
    Array<PickEnumerable<Prisma.ImpersonationLogGroupByOutputType, TArgs['by']> &
    {
        [P in ((keyof TArgs) & (keyof Prisma.ImpersonationLogGroupByOutputType))]: P extends '_count'
        ? TArgs[P] extends boolean
        ? number
        : Prisma.GetScalarType<TArgs[P], Prisma.ImpersonationLogGroupByOutputType[P]>
        : Prisma.GetScalarType<TArgs[P], Prisma.ImpersonationLogGroupByOutputType[P]>
    }
    > : InputErrors, TData = TQueryFnData, TError = DefaultError>(args: Prisma.SelectSubset<TArgs, Prisma.SubsetIntersection<TArgs, Prisma.ImpersonationLogGroupByArgs, OrderByArg> & InputErrors>, options?: (Omit<UseSuspenseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useSuspenseModelQuery<TQueryFnData, TData, TError>('ImpersonationLog', `${endpoint}/impersonationLog/groupBy`, args, options, fetch);
}

export function useCountImpersonationLog<TArgs extends Prisma.ImpersonationLogCountArgs, TQueryFnData = TArgs extends { select: any; } ? TArgs['select'] extends true ? number : Prisma.GetScalarType<TArgs['select'], Prisma.ImpersonationLogCountAggregateOutputType> : number, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.ImpersonationLogCountArgs>, options?: (Omit<UseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useModelQuery<TQueryFnData, TData, TError>('ImpersonationLog', `${endpoint}/impersonationLog/count`, args, options, fetch);
}

export function useSuspenseCountImpersonationLog<TArgs extends Prisma.ImpersonationLogCountArgs, TQueryFnData = TArgs extends { select: any; } ? TArgs['select'] extends true ? number : Prisma.GetScalarType<TArgs['select'], Prisma.ImpersonationLogCountAggregateOutputType> : number, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.ImpersonationLogCountArgs>, options?: (Omit<UseSuspenseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useSuspenseModelQuery<TQueryFnData, TData, TError>('ImpersonationLog', `${endpoint}/impersonationLog/count`, args, options, fetch);
}

export function useCheckImpersonationLog<TError = DefaultError>(args: { operation: PolicyCrudKind; where?: { createdById?: string; updatedById?: string; deletedById?: string; id?: string; sessionId?: string; primaryKey?: string; impersonator?: string; impersonated?: string; database?: string; schema?: string; table?: string; operation?: string }; }, options?: (Omit<UseQueryOptions<boolean, TError, boolean>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useModelQuery<boolean, boolean, TError>('ImpersonationLog', `${endpoint}/impersonationLog/check`, args, options, fetch);
}
